{{#if (and interface.hasResetAndOtherPorts (or (and isMaster (not isPipelined)) (or isTopSlaveSequence isVirtualSequence)))}}
virtual function bit killed_by_reset();
  return {{#with (or requestSequenceHandle slaveResponseSequenceBaseHandle)}}{{ identifier }}.{{/with}}rsp.killed_by_reset;
endfunction
{{/if}}
